import { render, staticRenderFns } from "./VentaPedidoConcepto.vue?vue&type=template&id=45a3bbf8&"
import script from "./VentaPedidoConcepto.vue?vue&type=script&lang=js&"
export * from "./VentaPedidoConcepto.vue?vue&type=script&lang=js&"
import style0 from "./VentaPedidoConcepto.vue?vue&type=style&index=0&id=45a3bbf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports